module.exports = __webpack_public_path__ + "d6b0c79b2f2b3cba4de54d9ece5b059b.jpg";